<template>
  <div>
    <adressItem :itemField="'area'" :refs="refs"></adressItem>
    <adressItem :itemField="'city'"  :refs="refs"></adressItem>
    <adressItem :itemField="'street'"  :refs="refs"></adressItem>
    <adressItem :itemField="'house'"  :refs="refs"></adressItem>
    <adressItem :itemField="'deportament'"  :refs="refs"></adressItem>
  </div>
</template>

<script>
  export default {
    name: "vmSelectDadataMobileWrap",
    props:{
      refs:{
        type:String,
        default:''
      }
    },
    components:{
      adressItem:()=>import('@/components/form/fmSelectDadataMobile')
    }
  }
</script>

<style scoped>

</style>
